import { useContext } from "react";
import { StepContext } from "../contexts";

const useStep = () => {
  return useContext(StepContext);
};

export default useStep;
